import { Component } from '@angular/core';
import { UserApiService } from 'src/app/dashboard/services/user-api.service';
import { ApiResponseTable } from 'src/app/dashboard/models/api-response-table';
import { ApiRequestModel } from 'src/app/models/api-request-model';
import { LoggerService } from 'src/app/services/logger.service';

@Component({
  selector: '.app-forgot-password.container-xxl',
  templateUrl: './forgot-password.component.html',
  styleUrls: [
    './forgot-password.component.css']
})

export class ForgotPasswordComponent{

  constructor(private logger: LoggerService
    , private apiService: UserApiService) {

  }

  public emailAddress: string = '';
  public validateMessage: string[] = [];
  public apiResponse!: ApiResponseTable;

  public onSubmit() {
    try {
      if (!this.checkValidation()) {
        return;
      }
      var url = `forgetpassword?email=${this.emailAddress}`
      this.apiService.postWhitoutToken(new ApiRequestModel(url))
        .subscribe(
          result => {
            this.apiResponse = result;
            
          },
          error => {
            if (error.error.text=="email not found") {
              this.validateMessage.push('ایمیل یافت نشد');
              return;
            }
            this.logger.addException(error,true);
          },
          () => {
            console.log(`Completed!`);
          }
          );
        } catch (error) {
      this.logger.addException(error,true);
    }
  }

  public checkValidation(): boolean {
    this.validateMessage = [];
    if (this.emailAddress == '' ||
      this.emailAddress == null) {
      this.validateMessage.push('مقدار ایمیل مشخص نشده است');
      return false;
    }

    const expression: RegExp = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    if (!expression.test(this.emailAddress)) {
      this.validateMessage.push('فرمت ایمیل صحیح نیست');
      return false;
    }

    return true;
  }

}
